export default __webpack_public_path__ + "static/media/technology.ad1c6a18.png";